import {
  DiscountLifeCyclePolicyEnum,
  IQuoteItemRespSchema,
} from '@monetize/types/app';
import { useMemo } from 'react';

export const useCustomDiscountExcludedOnRenewal = (
  item: IQuoteItemRespSchema,
): boolean => {
  return useMemo(() => {
    return (
      item.customDiscountLifecyclePolicies?.includes(
        DiscountLifeCyclePolicyEnum.EXCLUDE_FROM_RENEWAL,
      ) ?? false
    );
  }, [item.customDiscountLifecyclePolicies]);
};
